import {Component,OnInit,EventEmitter,Output} from "@angular/core";
import { LiquidacionService } from "../../../../services/liquidacion/liquidacion.service";
import { EmpresasService } from '../../../../services/empresas/empresas.service';
import {FormGroup, FormControl} from "@angular/forms";
import { environment } from 'environments/environment';

declare var $: any;

@Component({
  selector: 'app-correo-liquidaciones',
  templateUrl: './correo-liquidaciones.component.html',
  styleUrls: ['./correo-liquidaciones.component.scss']
})
export class CorreoLiquidacionesComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;

  dropdownList = [];
  selectedItems = [];
  abrirAgregarProveedor : boolean;
  idContactoS: string;
  
  dropdownSettings = {};
  requiredField: boolean = true;
  rProvCombo :any = [];
  inputDefault : any = [];
  searchField:string ="";

  idProveedor : number = 0;
  loading:boolean;
  save : boolean = false;
 
  error : boolean = false;
  textError: string = "";
  dataProveedor:any= [];
  link:any;
  

  proveedor:any= "cosorcio xd"
  url:any= "dgdgdasdgdsgdagdagdgadg"

  dataEnviar:any= {
    "idLiquidacion": "",
    "url_Liquidacion" : "",
    "correos":[]
  }

  dataPrueba: any =[
    {
      "nombre" : "Cristhofer Morales",
      "correo" : "cmorales@innovafactoring.com"
    },
    {
      "nombre" : "Rickolaz Ataucusi",
      "correo" : "jgallardo@innovafactoring.com"
    },
    {
      "nombre" : "Yudas as a as ",
      "correo" : "dchavez@innovafactoring.com"
    },
    {
      "nombre" : "Paul Rojas P",
      "correo" : "projas@innovafactoring.com"
    }

  ];

  @Output() cerrarCorreoLiquidacion = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();

  formularioEnviarCorreo : FormGroup;

  constructor(private liquidacionService: LiquidacionService,
    private EmpresasService1:EmpresasService) { 

    this.formularioEnviarCorreo = new FormGroup({
      idLiquidacion: new FormControl(''),
      url_Liquidacion : new FormControl(''),
      Correo : new FormControl('')
  });

  }

  ngOnInit() {
    this.dataProveedor = this.liquidacionService.proveedorCorreo
    this.idProveedor = this.dataProveedor.idProveedor;
    this.proveedor = this.dataProveedor.Proveedor;
    this.url = this.dataProveedor.Adjunto_PDF;
  
    this.dropdownSettings = {
      singleSelection: false,
      text: "Seleccione los correos a enviar",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: false,
      labelKey: 'NombreCorreo',
      primaryKey: 'idContacto',
      classes: "myclass custom-class",
      badgeShowLimit: 3
    };
    this.ListarRepresentantesProv(this.idProveedor);
  }

  ListarRepresentantesProv(idProv){
    this.loading = true;
    this.EmpresasService1.obtenerContactosEmpresa(idProv).subscribe(
      res => {       
          this.rProvCombo = res;
          console.log(this.rProvCombo);
          this.rProvCombo = this.rProvCombo.filter(
            state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 
          );
          this.inputDefault = this.rProvCombo.filter(
            state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Des_Tipo_de_Contacto.toLowerCase().indexOf('usuario') === 0
          );
        
          this.filterRecords(this.searchField);

          this.loading = false;
      },err =>{
        this.textError = err.error['error'];
        this.error = true;
        this.loading = false;
      }
    );
  }

  CerrarPopUp() {
    this.cerrarCorreoLiquidacion.emit();
  }
  Refresh() {
    this.ngOnInit();
  }

  enviarCorreos(){

    if (this.selectedItems.length == 0) {
      this.showNotification('warning','top','right','Seleccione correo');
      return
    }

    this.dataEnviar.idResumenLiquidacion = this.dataProveedor.idResumen_Liquidaciones
    this.dataEnviar.urlSimulador = this.dataProveedor.Adjunto_PDF
    this.dataEnviar.to = [];

    this.selectedItems.forEach(item => { 
    this.dataEnviar.to.push(
      {
        'nombre' : item.Nombre_de_Contacto,
        'correo' : item.Correo,
       }
    )

  });
      console.log(this.dataEnviar);
      this.loading = true      
      this.liquidacionService.EnviarCorreoPlanillaLiquidacion(this.dataEnviar)
      .subscribe(
        res => {
          this.save = false;
          this.loading = false;
          this.showNotification('success','top','right','Correo enviado exitosamente.');
        },err =>{
  
          let error = "";
          error = err.error.error;
          this.showNotification('danger','top','right','No se pudo enviar correo electrónico. \n' + error);
  
          this.error = true;
          this.loading = false;
        });


  }

  
  onItemSelect(item: any) {
    this.setStatus();
  }

  setStatus() {
    (this.selectedItems.length > 0) ? this.requiredField = true : this.requiredField = false;
  }
  


  OnItemDeSelect(item: any) {
    this.setStatus();
  }
  onSelectAll(items: any) {
    this.setStatus();
  }
  onDeSelectAll(items: any) {
    this.selectedItems = [];
    this.setStatus();
  }

  filterRecords(textToSearch: string) {
    let tempArray = [];
     this.inputDefault.forEach((item, index) => {
      if(item.Correo.indexOf(textToSearch.toLowerCase()) > -1) {
        tempArray.push(item);
      }
    })

    if(tempArray.length > 0){
      this.selectedItems = tempArray;
    }
  }

  obtenerpdf($file:any){
    window.open($file,"_blank");
  }

  CerrarPopUpProveedor(click:boolean){
   
    this.abrirAgregarProveedor = false;
   
 }
 nuevoContacto(){
   this.idContactoS = "";
   this.liquidacionService.addContactoLiquidacion = true;
   this.abrirAgregarProveedor = true;
}

  showNotification(type,from,align,message){
    
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
  

}
